import React from 'react';
import { Box, Typography } from '@mui/material';
import { DRAWER } from '../../../tokens';

// Shared header for the selected-process drawer panels (Metrics, Metadata, …): the
// service name with the display name + description below it. Keeps every tab consistent.
// Node panels pass `node`; edge/root panels (whose title/subtitle come from a different
// shape) pass `title`/`subtitle` explicitly.
export default function ServiceHeader({ node, title, subtitle }) {
  const resolvedTitle = title ?? node?.service_name;
  const resolvedSubtitle =
    subtitle ??
    `${node?.display_name ?? ''}${
      node?.description ? ` — ${node.description}` : ''
    }`;

  return (
    <Box
      sx={{
        px: 3,
        pt: 1,
        pb: 1.5,
        borderBottom: `1px solid ${DRAWER.border}`,
      }}
    >
      <Typography
        sx={{
          color: DRAWER.text,
          fontWeight: 700,
          fontSize: 26,
          lineHeight: 1.2,
          wordBreak: 'break-word',
        }}
      >
        {resolvedTitle}
      </Typography>
      <Typography sx={{ color: DRAWER.textMuted, fontSize: 14, mt: 0.5 }}>
        {resolvedSubtitle}
      </Typography>
    </Box>
  );
}
